@if (
  pageInfo?.['title'] != 'Analytical' &&
  pageInfo?.['title'] != 'eCommerce' &&
  !router.url.includes('/register-company-owner')
) {

<div class="modern-page-header">
  <div class="header-content">

    <div class="header-left">
      <div class="page-badge">
        <i-tabler name="layout-dashboard"></i-tabler>
      </div>

      <div>
        <h1>{{ pageInfo?.['title'] | translate }}</h1>

        <ul class="modern-breadcrumb">
          @for (url of pageInfo?.['urls']; track url.url; let last = $last) {

          @if(!last) {
          <li>
            <a [routerLink]="url.url">{{ url.title | translate }}</a>
          </li>
          <li class="separator">/</li>
          }

          @else {
          <li class="active">
            {{ url.title | translate }}
          </li>
          }

          }
        </ul>
      </div>
    </div>

    <div class="header-right">
      <div class="header-date">
        {{ today | date:'EEEE, MMM d':undefined:L.locale }}
      </div>
    </div>

  </div>
</div>

}